export const findLogoByName = (name) => {
  const imgName = name === 'INTERNAL_AGGREGATION' ? 'HUDDLE' : name;
  // eslint-disable-next-line
  return require(`/public/images/logos64x32/${imgName}.png`);
};
